<template>
  <button
      class="btn btn-green w-100"
      :class="{ 'disabled': isLoading }"
      :disabled="isDisable()"
      @click="handleClick"
  >
    <span
        class="spinner-border spinner-border-sm me-2"
        v-show="isLoading"
    ></span>
    <template v-if="!isNew">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           class="icon icon-tabler icons-tabler-outline icon-tabler-device-floppy">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2"/>
        <path d="M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/>
        <path d="M14 4l0 4l-6 0l0 -4"/>
      </svg>
      Сохранить
    </template>
    <template v-else>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           class="icon icon-tabler icons-tabler-outline icon-tabler-plus">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M12 5l0 14"/>
        <path d="M5 12l14 0"/>
      </svg>
      Создать
    </template>
  </button>
</template>

<script setup>
import {defineOptions, ref} from 'vue'
import Api from './Api'

defineOptions({
  name: "WishlistSaveWishBtn"
})

const props = defineProps({
  isNew: {
    type: Boolean,
    required: true
  },
  query: {
    type: Object,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['onSave'])

const isLoading = ref(false)

const handleClick = async () => {
  if (isLoading.value) return

  isLoading.value = true
  try {
    let wishId = props.isNew ? null : props.query.wish_id

    const response = await Api.saveWish(
        wishId,
        props.query.currency_id,
        props.query.theme_ids,
        props.query.wish_name,
        props.query.wish_desc_json,
        props.query.wish_amount,
        props.query.wish_alias,
        props.query.category_id,
    )

    const finalWishId = wishId || response?.wish_id

    if (finalWishId && Array.isArray(props.query.wish_links) && props.query.wish_links.length > 0) {
      const linkPromises = props.query.wish_links.map(item => {
        if (item && item.link) {
          return Api.saveWishLink(finalWishId, item.link)
        }
        return Promise.resolve(null)
      })

      await Promise.all(linkPromises)
    }

    emit('onSave', {
      success: true,
      resp: {
        wish_id: finalWishId ?? null
      },
    })
  } catch (error) {
    emit('onSave', {
      success: false,
    })
  } finally {
    isLoading.value = false
  }
}

function isDisable() {
  return isLoading.value || props.disabled === true
}
</script>
